<template>
  <div id="xlsx">
    <el-button
      type="success"
      size="small"
      style="float: right"
      @click="exportex"
      >导出</el-button
    >
  </div>
</template>
<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "数据表",
  props: {
    name: String,
    required: true,
  },
  // props: ['name'],
  data() {
    return {};
  },
  methods: {
    exportex() {
      this.exportExcel("exportTab", name);
    },
    exportExcel(id, title) {
      var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换
      // 存在fixed干掉
      let fix = document.querySelector(".el-table__fixed-right");
      let swb;
      if (fix) {
        swb = XLSX.utils.table_to_book(
          document.querySelector("#exportTab").removeChild(fix),
          xlsxParam
        );
        document.querySelector("#exportTab").appendChild(fix);
      } else {
        swb = XLSX.utils.table_to_book(
          document.querySelector("#exportTab"),
          xlsxParam
        );
      }
      /* generate workbook object from table */

      // var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)
      var wbout = XLSX.write(swb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          `${JSON.parse(this.name).name}.xlsx`
        );
      } catch (e) {
        if (typeof console !== "undefined") {
          console.log(e, wbout);
        }
      }
      return wbout;
    },
  },
};
</script>
<style lang="scss">
</style>